import React, { Component } from 'react';
import App_data from '../../config/App_data';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import FD from '../../RestAPI/fetchData';
import Cfa2SubscriptionCheck from '../../RestAPI/Cfa2Subscription';
import PartnerCfa2SubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa2Subscription';
import language from '../../../assets/languages/language';
import AlertMessage from '../../config/alertMessage';
import ModalComponent from '../../Common/Modal';
import PDFModelComponent from '../../Common/PDFModel';
import AppRoutes from '../../config/AppRoutes';
import { examNameAccordingToDB } from '../../../common/constant';
import userStore from "../../../store/userStore";
import { showInformation } from '../../../common/toast';
/* eslint-disable*/
class Cfa22023cases extends Component {
  constructor(props) {
    window.scrollTo(0, 0);
    super(props);
    this.state = {
      alert_status: false,
      pdfAlert: false,
      MessageTitle: `${language.LC().MESSAGE}`,
      MessageContent: `${language.LC().READING_NOT_FOUND}`,
      changeStatusTitle: `${language.LC().Mark_this_Question_as_Completed}`,
      readings: [],
      token: '',
      idname: '',
      chapterid: this.props.params.id,
      ValidToken: false,
      chapter_id: '',
      no_result_display: '',
      selectedmenu: 'cfa_2',
      subscriptionstatus: '',
      change_status: false,
      change_case_no: '',
      change_completion_status: '',
      markAsCompleted: false,
      markAsNotCompleted: false,
      markCompleted: true,
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      premiumAlertStatus: false,
      pdfLoading: true,
      pdfLoadingAnswer: true,
      PDFDownloadType: 'Question',
      PDFContentMessage: language.LC().PDFContentMessage,
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    this.toggleAlertChangeStatus = this.toggleAlertChangeStatus.bind(this);
    this.pdfAlertModel = this.pdfAlertModel.bind(this);
  }

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  pdfAlertModel() {
    this.setState({
      pdfAlert: !this.state.pdfAlert,
    });
  }
  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlertChangeStatus(item, index) {
    // console.log(item)
    // console.log(index)
    {
      item.completionStatus === 1
        ? this.setState({
            change_status: !this.state.change_status,
            change_case_no: item.case_number,
            change_completion_status: item.completionStatus,
            markAsCompleted: true,
            markAsNotCompleted: false,
          })
        : this.setState({
            change_status: !this.state.change_status,
            change_case_no: item.case_number,
            change_completion_status: item.completionStatus,
            markAsNotCompleted: true,
            markAsCompleted: false,
          });
    }
  }

  markCompleted() {
    // console.log('markCompleted')
    this.setState({
      markAsCompleted: true,
      markAsNotCompleted: false,
      markCompleted: false,
    });
  }

  markNotCompleted() {
    // console.log('markNotCompleted')
    this.setState({
      markAsCompleted: false,
      markAsNotCompleted: true,
      markCompleted: false,
    });
  }

  changeCompletionStatus(e) {
    e.preventDefault();
    // console.log('changeCompletionStatus working')
    if (this.state.markAsCompleted === true) {
      // console.log('Mark as completed')
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        case_no: this.state.change_case_no,
        completion_status: this.state.markAsCompleted,
        exam_type: this.state.selectedmenu,
        chapter_id: this.state.chapterid,
      };
      // console.log(data)
      FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/updateCases', data).then(resp => {
        if (resp.success) {
          // console.log(resp.message)
          var data = {
            token: this.state.token,
            idname: this.state.idname,
            chapter_id: this.state.chapterid,
            subscriptionstatus: this.state.subscriptionstatus,
          };
          FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getCasessubs', data).then(
            resp => {
              // console.log(resp);
              if (resp.success) {
                this.setState({
                  ValidToken: true,
                  readings: resp.readings,
                  change_status: false,
                });
                if (!resp.readings.length) {
                  this.setState({ no_result_display: 'No Saved Questions' });
                }
              } else {
                this.setState({ ValidToken: false });
              }
              return resp;
            },
          );
        }
      });
    } else {
      // console.log('Mark as Un-Completed')
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        case_no: this.state.change_case_no,
        completion_status: this.state.markAsCompleted,
        exam_type: this.state.selectedmenu,
        chapter_id: this.state.chapterid,
      };
      // console.log(data)
      FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/updateCases', data).then(resp => {
        if (resp.success) {
          // console.log(resp.message)
          var data = {
            token: this.state.token,
            idname: this.state.idname,
            chapter_id: this.state.chapterid,
            subscriptionstatus: this.state.subscriptionstatus,
          };
          FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getCasessubs', data).then(
            resp => {
              // console.log(resp);
              if (resp.success) {
                this.setState({ ValidToken: true });
                this.setState({ readings: resp.readings, change_status: false });
                if (!resp.readings.length) {
                  this.setState({ no_result_display: 'No Saved Questions' });
                }
              } else {
                this.setState({ ValidToken: false });
              }
              return resp;
            },
          );
        }
      });
    }
  }

  //Function to redirect page to question bank page
  _getChapters = e => {
    this.context.router.push({
      pathname: AppRoutes.CFA2_2025_QUESTION_BANK,
    });
  };

  togglePremiumAlert() {
    this.setState({
      premiumAlertStatus: !this.state.premiumAlertStatus,
    });
  }

  //Function to redirect page on specifc questions
  _beginChapter = (reading, index, e) => {
    //console.log("readog", reading);
    // console.log(
    //   'readingreadingreadingreadingreadingreadingreadingreadingreadingreadingreadingreadingreading---------------------------------',
    //   reading
    // );
    // console.log('indexindexindexindexindex', index);

    const { subscriptionstatus } = this.state;
    if (subscriptionstatus === 'free' && reading.free == 0) {
      this.togglePremiumAlert();
    } else {
      this.context.router.push({
        pathname: AppRoutes.CFA2_2025_QUESTION_BANK_CASES_QUESTION.replace(
          ':chapterid',
          this.state.chapterid,
        )
          .replace(':caseid', reading.id)
          .replace(':case_offset', index)
          .replace(':question_number', 1)
          .replace(':offset', 0),
      });
    }
  };

  componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var final_exam = [];
    var user_data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(resp => {
    userStore.getUserProfile(true).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({ subscriptionstatus: 'free' });
          this._runCode('free');
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var = await PartnerCfa2SubscriptionCheck.checkCfa2Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  examPlanData,
                );
                if (isInArray_var) {
                  this.setState({ subscriptionstatus: 'paid' });
                  this._runCode('paid');
                } else {
                  this.setState({ subscriptionstatus: 'free' });
                  this._runCode('free');
                }
              } else {
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.setState({ subscriptionstatus: 'free' });
          this._runCode('free');
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = Cfa2SubscriptionCheck.checkCfa2Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var) {
                  this.setState({ subscriptionstatus: 'paid' });
                  this._runCode('paid');
                } else {
                  this.setState({ subscriptionstatus: 'free' });
                  this._runCode('free');
                }
              } else {
              }
            },
          );
        }
      }
    });
  }

  _runCode(subscriptionstatus) {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      chapter_id: this.state.chapterid,
      subscriptionstatus: subscriptionstatus,
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getCasessubs', data).then(resp => {
      // console.log(resp);
      if (resp.success) {
        this.setState({ ValidToken: true });
        this.setState({ readings: resp.readings });
        if (!resp.readings.length) {
          this.setState({ no_result_display: 'No Saved Questions' });
        }
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  }
  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }

  getpdf = async e => {
    //console.log("inside functionnn");
    if (this.state.pdfLoading == false) {
      alert('Download is in progress....');
      return;
    }
    if (this.state.pdfLoadingAnswer == false) {
      alert('Please wait one process is in queue.');
      return;
    }
    var user_data = {
      token: this.state.token,
      idname: this.state.idname,
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
      // console.log("resp", resp);
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.togglePremiumAlert();
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              //console.log("resp_exam", resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var_PDF = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var_PDF = await PartnerCfa2SubscriptionCheck.checkCfa2Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  examPlanData,
                );
                if (isInArray_var_PDF) {
                  this.setState({
                    pdfLoading: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/cfa_2_2025question_bank/Q-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
                      this.setState({ pdfLoading: true });
                      showInformation(response.message || "The PDF for this topic is not available yet.");
                    }
                  });
                } else {
                  this.togglePremiumAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.togglePremiumAlert();
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              //console.log("resp_exam", resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var_PDF = false;
                //console.log("isInArray_var_PDF before", isInArray_var_PDF);
                isInArray_var_PDF = await Cfa2SubscriptionCheck.checkCfa2Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                //console.log("isInArray_var_PDF after", isInArray_var_PDF);
                if (isInArray_var_PDF) {
                  this.setState({
                    pdfLoading: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/cfa_2_2025question_bank/Q-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
                      this.setState({ pdfLoading: true });
                      showInformation(response.message || "The PDF for this topic is not available yet.");
                    }
                  });
                } else {
                  this.togglePremiumAlert();
                }
              } else {
              }
            },
          );
        }
      }
    });
  };
  /*
--------------------------------
  PDF DOWNLOAD Via email Answer
--------------------------------
*/
  getpdfAnswer = async e => {
    if (this.state.pdfLoadingAnswer == false) {
      alert('Download is in progress....');
      return;
    }
    if (this.state.pdfLoading == false) {
      alert('Please wait one process is in queue.');
      return;
    }

    var user_data = {
      token: this.state.token,
      idname: this.state.idname,
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.togglePremiumAlert();
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var_PDF = false;
                // #261 — pass examPlanData so the mock-package early-return
                // fires (otherwise partner with mock-only plan got a PDF email).
                const examPlanData = resp_exam.examPlan && resp_exam.examPlan[0];
                isInArray_var_PDF = await PartnerCfa2SubscriptionCheck.checkCfa2Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  examPlanData,
                );
                if (isInArray_var_PDF) {
                  this.setState({
                    pdfLoadingAnswer: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/cfa_2_2025question_bank/QA-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
                      this.setState({ pdfLoadingAnswer: true });
                      showInformation(response.message || "The PDF for this topic is not available yet.");
                    }
                  });
                } else {
                  this.togglePremiumAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.togglePremiumAlert();
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              // console.log(resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var_PDF = false;

                isInArray_var_PDF = await Cfa2SubscriptionCheck.checkCfa2Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var_PDF) {
                  this.setState({
                    pdfLoadingAnswer: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/cfa_2_2025question_bank/QA-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      // No pre-generated PDF yet: say so (like the mock PDFs) instead of the "export initiated" modal.
                      this.setState({ pdfLoadingAnswer: true });
                      showInformation(response.message || "The PDF for this topic is not available yet.");
                    }
                  });
                } else {
                  this.togglePremiumAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  render() {
    // console.log(this.state.readings)
    // console.log(this.state.readings[1])
    const { subscriptionstatus, premiumAlertStatus } = this.state;
    let readings = this.state.readings;
    let data = '';
    if (this.state.readings.length) {
      data = readings.map((item, index) => (
        <tr key={index}>
          <td>{/*item.case_number*/ index + 1}.</td>
          <td>{item.case_name_2025}</td>
          <td>
            {subscriptionstatus === 'free' && item.free == 0 ? (
              <span className='tooltip_wrap'>
                <img
                  src={App_data.frontend_url + '/img/subsciption-dark.svg'}
                  className='pointer_class'
                  alt=''
                  width='21'
                  id={item.id}
                  onClick={this._beginChapter.bind(this, item, index)}
                  title=''
                />
                <div className='tootip_box'>{language.LC().UPGRADE_ACCOUNT}</div>
              </span>
            ) : (
              <span className='tooltip_wrap'>
                <img
                  src={App_data.frontend_url + '/img/question_bank/open_book_icon.svg'}
                  className='pointer_class'
                  alt=''
                  width='21'
                  id={item.id}
                  onClick={this._beginChapter.bind(this, item, index)}
                  title=''
                />
                <div className='tootip_box'>{language.LC().BEGIN_CASES}</div>
              </span>
            )}
          </td>
          {subscriptionstatus === 'free' && item.free == 0 ? null : readings[index]
              .completionStatus === null ||
            readings[index].completionStatus === false ||
            readings[index].completionStatus === 0 ? (
            <td>
              <div className='complete-or-not'>
                <span className='complete-or-not-text'> {language.LC().NOT_COMPLETED}</span>
                <span className='tooltip_wrap left-tool-tip'>
                  <img
                    src={App_data.frontend_url + '/img/question_bank/edit-icon.svg'}
                    className='pointer_class'
                    alt=''
                    width='15'
                    id={item.id}
                    onClick={this.toggleAlertChangeStatus.bind(this, item, index)}
                    title=''
                  />
                  <div className='tootip_box'> {language.LC().CHANGE_STATUS} </div>
                </span>
              </div>
            </td>
          ) : (
            <td>
              <div className='complete-or-not'>
                <span className='complete-or-not-text'>{language.LC().COMPLETED} </span>
                <span className='tooltip_wrap left-tool-tip'>
                  <img
                    src={App_data.frontend_url + '/img/question_bank/edit-icon.svg'}
                    className='pointer_class'
                    alt=''
                    width='15'
                    id={item.id}
                    onClick={this.toggleAlertChangeStatus.bind(this, item, index)}
                    title=''
                  />
                  <div className='tootip_box'> {language.LC().CHANGE_STATUS} </div>
                </span>
              </div>
            </td>
          )}
        </tr>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }

    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-md-8 margin_bottom_20'>
            <h1 className='section_head'>{this.props.params.chapter_name}</h1>
          </div>
          <div className='col-md-4 text-md-right margin_bottom_20 question-download-reading-page'>
            <div onClick={this.getpdf.bind(this)} className='status-download-btn margin_right_10'>
              <a className='btn btn-primary  pointer_class pull-right'>
                {this.state.pdfLoading ? (
                  <i className='fa fa-download' aria-hidden='true' />
                ) : (
                  <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                )}
                {this.state.subscriptionstatus === 'free' ? (
                  <div className='premium-download'>{language.LC().PREMIUM}</div>
                ) : null}
                {this.state.pdfLoading ? language.LC().Download_Q_Cases : '  please wait...'}
              </a>
            </div>
            <div
              onClick={this.getpdfAnswer.bind(this)}
              className='status-download-btn margin_right_10'
            >
              <a className='btn btn-primary  pointer_class pull-right max-width-200'>
                {this.state.pdfLoadingAnswer ? (
                  <i className='fa fa-download' aria-hidden='true' />
                ) : (
                  <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                )}
                {this.state.subscriptionstatus === 'free' ? (
                  <div className='premium-download'>{language.LC().PREMIUM}</div>
                ) : null}
                {this.state.pdfLoadingAnswer ? language.LC().Download_QA_Cases : '  please wait...'}
              </a>
            </div>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getChapters}
            >
              {' '}
              {language.LC().CHANGE_TOPIC}
            </button>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12'>
            <div className='card height_70vh'>
              <div className='card-header'>
                {language.LC().CASE_STUDIES} - {this.props.params.chapter_name}
              </div>
              <div className='table_responsive_wrapper'>
                <div className='table-responsive'>
                  <table className='table_white_bg table'>
                    <thead>
                      <tr className='border_top_0 case-study-heading-wrap'>
                        <th width='90'>#</th>
                        <th> {language.LC().CASE_NAME} </th>
                        <th className='action-heading'>{language.LC().ACTION}</th>
                        <th className='status-heading'>{language.LC().STATUS}</th>
                      </tr>
                    </thead>
                    <tbody>{data}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={this.state.alert_status}
          toggle={this.toggleAlert}
          className={'modal-primary ' + this.props.className}
        >
          <ModalHeader toggle={this.toggleAlert}>{this.state.MessageTitle}</ModalHeader>
          <ModalBody>
            <div className='d-flex flex-column'>
              <div> {this.state.MessageContent}</div>
              <div className='text-right'>
                {' '}
                <Button color='primary' onClick={this.toggleAlert}>
                  {' '}
                  {language.LC().OK}{' '}
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.change_status}
          toggle={this.toggleAlertChangeStatus}
          className={'modal-primary complete-or-not-model ' + this.props.className}
        >
          <ModalHeader toggle={this.toggleAlertChangeStatus}>
            {this.state.changeStatusTitle}
          </ModalHeader>
          <ModalBody>
            <div className='card-block card-padding'>
              <div className='row'>
                <div className='col-sm-12 text-center'>
                  <div className='row'>
                    <div className='col-sm-12 col-md-12 '>
                      <div className='quation-img'>
                        <img
                          src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
                          className='margin_bottom_10'
                          alt=''
                        />
                      </div>
                      <div
                        contentEditable='false'
                        suppressContentEditableWarning={true}
                        className='margin_bottom_10 view_questionhtml bg_blue_status'
                      >
                        {' '}
                        {language.LC().MARK_THIS_QUESTION_AS_COMPLETED}{' '}
                      </div>
                    </div>
                    <div className='complete-or-not-wrap'>
                      <div className='check-button-wrap'>
                        <div className='card-actions float-right'>
                          <label className='check_container margin_bottom_0'>
                            {' '}
                            {language.LC().COMPLETED}
                            <input
                              type='checkbox'
                              id='mark_completed'
                              name='mark_completed'
                              value='select'
                              onClick={this.markCompleted.bind(this)}
                              checked={this.state.markAsCompleted}
                            />
                            <span className='checkmark' />
                          </label>
                        </div>
                        <div className='card-actions float-right'>
                          <label className='check_container margin_bottom_0'>
                            {language.LC().NOT_COMPLETED}
                            <input
                              type='checkbox'
                              id='mark_not_completed'
                              name='mark_not_completed'
                              value='select'
                              onClick={this.markNotCompleted.bind(this)}
                              checked={this.state.markAsNotCompleted}
                            />
                            <span className='checkmark' />
                          </label>
                        </div>
                      </div>
                      <div className='d-block text-center complete-quation-submit'>
                        <button
                          disabled={this.state.markCompleted}
                          onClick={this.changeCompletionStatus.bind(this)}
                          className='btn btn-primary pointer_class'
                        >
                          {' '}
                          {language.LC().SUBMIT}{' '}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.togglePremiumAlert.bind(this)}
          alert_status={premiumAlertStatus}
          MessageContent={AlertMessage.messageContent_cfa_2}
          exam={examNameAccordingToDB.CFA_2}
        />

        <PDFModelComponent
          type={this.state.PDFDownloadType}
          pdfAlertModel={this.pdfAlertModel.bind(this)}
          pdfAlert={this.state.pdfAlert}
          PDFContentMessage={this.state.PDFContentMessage}
        />
      </div>
    );
  }
}

export default Cfa22023cases;



// WEBPACK FOOTER //
// ./src/views/CFA2-2025/QuestionBank/Cfa2cases.js